import { useEffect, useState } from 'react';
import { CardHeader, CardContent, Typography, Avatar, CircularProgress, Box, Dialog, DialogTitle, DialogContent, IconButton, Alert, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import Link from '@mui/material/Link';

const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"]

const LatestAnnouncement = () => {
  const [announcement, setAnnouncement] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); 

  useEffect(() => {
    async function fetchAnnouncement() {
      setLoading(true);
      try {
        const res = await fetch(`${BACKEND_HOST}/announcements?sort=createdAt:desc&populate[]=user_profile&populate[]=user_profile.pic`);
        const data = await res.json();
        const first = Array.isArray(data.data) ? data.data[0] : data.data?.[0] || null;
        if (first === null) {
          setLoading(false);
          return;
        }
        const oldDate = new Date();
        oldDate.setDate(oldDate.getDate() - 7);
        if (first.publishedAt && new Date(first.publishedAt) < oldDate) {
          setLoading(false);
          return;
        }
        setAnnouncement(first);
      } catch (err) {
        setError('Failed to load announcement');
      } finally {
        setLoading(false);
      }
    }
    fetchAnnouncement();
  }, []);

  if (announcement === null) {
    return null;
  }

  return <Announcement announcement={announcement} loading={loading} error={error} />;
};


const Announcement = ({announcement, loading, error}) => {

   const [open, setOpen] = useState(false);

  if (loading) return <Box display="flex" justifyContent="center" alignItems="center" minHeight={120}><CircularProgress /></Box>;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!announcement) return null;

  const { title, body, user_profile } = announcement || announcement;
  const user = user_profile


  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {title}
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <CardHeader
            avatar={user?.pic?.formats?.thumbnail?.url ? (
              <Avatar src={user.pic.formats.thumbnail.url} />
            ) : (
              <Avatar>{user?.name?.[0] || '?'}</Avatar>
            )}
            title={user?.name}
          />
          <CardContent>
            <Box><Typography variant="caption" color="text.secondary">{new Date(announcement.publishedAt).toLocaleDateString()}</Typography></Box>
            <ReactMarkdown components={{
                a: Link,
            }}>{body}</ReactMarkdown>
          </CardContent>
        </DialogContent>
      </Dialog>
      
        <Box sx={{ mt: 2, mb: 1 }}>
          <Alert icon={false} action={
            <Box pt={1}>
              <Button color="info" variant="contained" size="small" onClick={() => setOpen(true)}>
                Read more
              </Button>
            </Box>

            
          }>
            <strong>{title}</strong>
          <Box><Typography variant="caption" color="text.secondary">{new Date(announcement.publishedAt).toLocaleDateString()}</Typography></Box>
          </Alert>
        </Box>

    </>
  );
};
export { LatestAnnouncement };
export default Announcement;
